<template>
    <div id="question-zone">
        <div id="number-question">
            Question 2/3
        </div>
        <div id="question">
            <h2>Terminez la phrase suivante : </h2>
            <p>Les principaux risques liés à une immunosuppression continue sont</p>
            <select :disabled="validationQ2" name="Q2-select" v-model="choiceQ2" title="Question 2">
                <option disabled value="">Sélectionnez la bonne suite</option>
                <option value="Un risque accru d’infections opportunistes et de malignités">Un risque accru
                    d’infections opportunistes et de malignités
                </option>
                <option value="Un risque accru d’infections opportunistes ">Un risque accru d’infections
                    opportunistes
                </option>
                <option value="Un risque accru de diabète de type 2 et d’obésité morbide">Un risque accru de diabète
                    de type 2 et d’obésité morbide
                </option>
            </select>
            <div id="result">
                <div>
                    <span id="message" v-show="validationQ2">
                        texte
                    </span>
                </div>
                <transition name="button-transition" leave-active-class="animated fadeOutDown"
                            enter-active-class="animated fadeInUp" mode="out-in">
                    <button @click="emitNextQ" key="Valid" v-if="validationQ2">
                        Suivant →
                    </button>
                    <button @click="validationQ2M" :disabled="choiceQ2 === ''" key="NoValid" v-else>
                        Validez →
                    </button>
                </transition>

            </div>


        </div>
    </div>
</template>
<script>
    export default {
        name: 'Question2',
        data() {
            return {
                choiceQ2: '',
                validationQ2: false
            }
        },
        methods: {
            validationQ2M() {
                if (this.choiceQ2 === "Un risque accru d’infections opportunistes et de malignités") {
                    $('#message').addClass('true').text("Ceci est la bonne réponse")
                } else {
                    $('#message').addClass('false').text("La bonne réponse était « Un risque accru d’infections opportunistes et de malignités »")
                }
                this.validationQ2 = true

            },
            emitNextQ() {
                this.$emit('next')
            }
        },
    }
</script>

<style lang="scss" scoped>
    p {
            font-size: 1.75rem;
        }

        select {
            max-width: 800px;
            cursor: pointer;
            padding: 20px 10px;
            outline: none;
            width: 100%;
            position: relative;
            border: 1px solid #e5e5e5;
            cursor: pointer;
            font-size: 1.25rem;
            font-weight: bold;
            box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
        }
</style>

<style lang="scss">
    @import "../../assets/css/default";
</style>
